export default __webpack_public_path__ + "static/media/Settings.4429f496.svg";